import type { Template } from '@commons/components/RichText/templates';
import Separator from '@commons/components/Separator';

/**
 * Dash CKEditor template.
 *
 * @returns A rendered React component.
 */

const DashTemplate: Template = () => <Separator dash color="primary" marginBottom="sm" />;

export default DashTemplate;
